import { useRequiredContext } from "@redotech/react-util/context";
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { RedoMerchantClientContext } from "../client/context";
import { RedoMerchantRpcClientContext } from "../rpc-client";
import { MerchantAppEventServer } from "./merchant-app-event-server";

export const MerchantAppEventServerContext = createContext<
  MerchantAppEventServer | undefined
>(undefined);

export function MerchantAppEventServerProvider({
  children,
}: {
  children?: ReactNode | ReactNode[];
}) {
  const client = useRequiredContext(RedoMerchantClientContext);
  const rpcClient = useContext(RedoMerchantRpcClientContext);

  const [eventServer, setEventServer] = useState(() =>
    rpcClient ? new MerchantAppEventServer(client, rpcClient) : undefined,
  );

  useEffect(() => {
    return () => {
      eventServer?.cleanup();
    };
  }, [eventServer]);

  useEffect(() => {
    setEventServer((prevEventServer) => {
      prevEventServer?.cleanup();
      return rpcClient
        ? new MerchantAppEventServer(client, rpcClient)
        : undefined;
    });
  }, [client, rpcClient]);

  return (
    <MerchantAppEventServerContext.Provider value={eventServer}>
      {children}
    </MerchantAppEventServerContext.Provider>
  );
}
